import { apiSlice } from "../../app/api/apiSlice";

export const exportJobApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		exportJob: builder.mutation({
			query: (credentials) => {
				console.log("createExportJob credentials:", credentials);

				return {
					url: `/api/v1/loan/create_export_jobs/${credentials?.loanGuid}/`,
					method: "POST",
					body: credentials?.formData,
				};
			},
		}),
	}),
});

export const { useExportJobMutation } = exportJobApiSlice;
